import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';

export const PublicEndedWatchedProductsRoute = (
  <Route
    key="watched_products/shared/:profile_slug/ended"
    path="watched_products/shared/:profile_slug/ended"
    handle={{
      clientSide: true,
      pageViewEvent: {
        pageName: MParticlePageName.PublicEndedWatchList,
      },
    }}
    lazy={async () => ({
      Component: (await import(
        '../components/watchlist/public_watchlist_layout'
      )).default,
    })}
  />
);
